import * as R from 'ramda'
import { GetNewMediaQueries } from 'domain/screenSize.types'

export const getNewMediaQueries: GetNewMediaQueries = R.mapObjIndexed(
  mediaQuery => ((mediaQuery.length > 1)
    ? (window.innerWidth > mediaQuery[0] && window.innerWidth < mediaQuery[1])
    : (window.innerWidth > mediaQuery[0]))
)
